<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="800"
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="primary" class="hidden-sm-and-up">
        <v-btn icon @click.native="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <template v-if="retrieved"> Edit {{ retrieved.firstName }} {{ retrieved.lastName }} </template>
          <template v-else>
            Please wait...
          </template>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items class="mr-0">
          <v-btn dark text @click.native="$router.push({ name: 'logout' })">Logout</v-btn>
          <v-btn dark text @click.native="save">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-title class="headline hidden-xs-only">
        <template v-if="retrieved"> Edit {{ retrieved.firstName }} {{ retrieved.lastName }} </template>
        <template v-else>
          Please wait...
        </template>
      </v-card-title>
      <v-card-text style="height: 100%">
        <div v-if="isLoading" class="dialog-spinner">
          <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
        </div>
        <template v-else>
          <VesselForm
            v-if="item"
            ref="form"
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="item"
            :errors="violations"
            :initial-values="retrieved"
          />
        </template>

        <v-dialog v-model="errorDialog" max-width="290">
          <v-card>
            <v-card-text>There was an error submitting the form</v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="green darken-1" text @click.native="errorDialog = false">Cancel</v-btn>
              <v-btn
                color="green darken-1"
                text
                @click.native="
                  $refs.form.onSubmit(item)
                  errorDialog = false
                "
                >Try again</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>

      <v-card-actions v-if="!isLoading" class="hidden-xs-only">
        <div class="flex-grow-1"></div>
        <v-btn color="green darken-1" text @click.native="$router.push({ name: 'logout' })">Logout</v-btn>
        <v-btn color="green darken-1" text @click.native="close">Cancel</v-btn>
        <v-btn color="green darken-1" text @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VesselForm from './Form.vue'

export default {
  components: {
    VesselForm
  },

  props: {
    userprofileIri: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      item: {},
      errorDialog: false
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'userprofile/update/isLoading',
      error: 'userprofile/update/error',
      retrieved: 'userprofile/update/retrieved',
      updated: 'userprofile/update/updated',
      violations: 'userprofile/update/violations',
      userProfile: 'userprofile/show/retrieved'
    }),
    dialog: {
      // getter
      get: function() {
        return this.show
      },
      // setter
      set: function(show) {
        if (false === show) {
          this.close()
        }
      }
    }
  },

  watch: {
    dialog: function(dialog) {
      if (dialog) {
        this.retrieve(this.userprofileIri)
      } else {
        this.reset()
      }
    },

    updated: function(updated) {
      if (!updated) {
        return
      }
      this.getUserProfile(this.userprofileIri)
      this.close()
    },
    error: function(error) {
      if (!error) {
        return
      }

      this.errorDialog = true
    }
  },

  created() {
    this.retrieve(this.userprofileIri)
  },

  methods: {
    ...mapActions({
      retrieve: 'userprofile/update/retrieve',
      update: 'userprofile/update/update',
      updateRetrieved: 'userprofile/update/updateRetrieved',
      reset: 'userprofile/update/reset',
      getUserProfile: 'userprofile/show/retrieve'
    }),

    close() {
      this.$emit('showUserProfileUpdateDialog', null)
    },

    save() {
      this.$refs.form.onSubmit(this.item)
    },

    onSendForm() {
      this.update()
    },

    updateField(field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
